<template>
  <div>
    <div class="display-range" @click="$bvModal.show('change-range')">
      {{ currentRangeTitle }}
    </div>

    <b-modal style="text-align: left;" id="change-range" title="Change Indicator Range" centered hide-footer>
      <b-form>
        <b-form-group style="margin-top: 1em" label="Select Non Standard Ranges:">
          <b-select v-model="rangeId" :options="options"></b-select>
        </b-form-group>
        <b-button size="sm" @click="saveRange">Save Range</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "indicator-range",
  data() {
    return {
      rangeId: null,
    };
  },
  methods: {
    saveRange() {
      this.setCurrentRangeId(this.rangeId);
      this.$bvModal.hide("change-range");
    },
    ...mapMutations(["setCurrentRangeId"]),
    ...mapActions(["notify"]),
  },
  computed: {
    options() {
      return this.getRangeBooks.map(x => ({ text: x.name, value: x.id }));
    },
    ...mapGetters(["getRangeBooks", "currentRangeTitle"]),
  },
};
</script>

<style lang="scss" scoped>
.display-range {
  position: fixed;
  right: 1.5em;
  top: 3.5em;
  cursor: pointer;
}
</style>